import { DELETE_STORE_EMPLOYEE } from "../constants/endpoints";
import axiosClient from "./axios";

class deleteStoreEmployee {
  static async deleteStoreEmployee(userId: string) {
    const response = await axiosClient.delete(
      DELETE_STORE_EMPLOYEE.replace(":userId", userId)
    );
    return response;
  }
}

export default deleteStoreEmployee;
